module.exports = __webpack_public_path__ + "img/border1.85657d23.png";